import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, NavbarText } from 'reactstrap';
import { Link, NavLink } from "react-router-dom";
// import "./css/compStyle.css";
import { withRouter } from 'react-router-dom';
import LoginModal from './LoginModal'
import { Link as RouterLink, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { LOGIN, LOGOUT } from '../../Pages/ReduxStore/slices/authSlice';

function HeaderComponent(props) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  
  const UserDropdown = ({reduxLogout}) => {
    return (
      <UncontrolledDropdown nav>
        <DropdownToggle nav caret className="text-white">
          {props.username}
        </DropdownToggle>
        <DropdownMenu className="my-" right>
          <DropdownItem className="my-0 ml-0 pl-3">
            <NavLink activeClassName="active" className="py-1 nav-link comp-nav mx-1" style={{ border: "0px" }}  to={"/users/" + props.username}>Profile</NavLink>
          </DropdownItem>
          <DropdownItem className="my-0 ml-0 pl-3" divider />
          <DropdownItem className="my-0 ml-0 pl-3">
            <Link activeClassName="active" className="py-1 nav-link comp-nav mx-1" style={{ border: "0px" }}  onClick={logMeOut}>Logout</Link>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
  const logMeOut = () => {
    props.reduxLogout();
    props.history.push("/contests");
  }
  const LogoutBtn = () => {
    return (
      <NavItem className="nav-buttons">
        <button className="btn btn-light" onClick={toggleModal}>Login</button>
      </NavItem>
    );
  }
  const NavBtn = () => {
    return (props.isAuthenticated ? <UserDropdown logMeOut={logMeOut} /> : <LogoutBtn />);
  }
  return (
    <>
      <Navbar className="font-head nav-partial" dark expand="md" fixed="top" >
        <div className="container">
          <NavbarBrand href="/">
            <RouterLink className="nav-logo" to="/"><img src="/assets/img/codeium_logo_bg.png" alt="Codeium" width="160px" /></RouterLink>
          </NavbarBrand>
          <NavbarToggler onClick={toggle} />
          <Collapse className="ml-md-5" isOpen={isOpen} navbar>
            <Nav className="mr-auto d-flex align-items-center" navbar>
              {/* <NavItem>
                <NavLink activeClassName="active" className="nav-link comp-nav mx-1" to="/problems">PRACTICE</NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink activeClassName="active" className="nav-link comp-nav mx-1" to="/contests">CONTESTS</NavLink>
              </NavItem>
              <NavItem>
                <NavLink activeClassName="active" className="nav-link comp-nav mx-1" to="/leaderboard">LEADERBOARD</NavLink>
              </NavItem>
              <NavItem>
                <NavLink activeClassName="active" className="nav-link comp-nav mx-1" to="/store">STORE</NavLink>
              </NavItem>
            </Nav>
            <Nav className="ml-md-auto  d-flex justify-content-center">
              <NavBtn />
            </Nav>
          </Collapse>
        </div>
      </Navbar><br /><br />
      <LoginModal toggleModal={toggleModal} isModalOpen={isModalOpen} />

    </>
  );
}

const mapStateToProps = state => {
  return {
    username: state.auth.username,
    isAuthenticated: state.auth.isAuthenticated 
  }
}

const mapDispatchToProps = dispatch => {
  return {
    reduxLogin: (username) => dispatch(LOGIN(username)),
    reduxLogout: () => dispatch(LOGOUT())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HeaderComponent));